






























































import { Vue, Component } from 'vue-property-decorator';

import { BusinessOnboardingAccountForm } from '@/models/business-onboarding';

import SignupService from '@/api/SingupService';
import CoinSetupService from '@/api/CoinSetupService';
import InternationalizationService from '@/api/InternationalizationService';

import TextField from '@/components/atoms/TextField/TextField.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import AccountForm, {
  AccountFormData
} from '@/componentsV2/templates/AccountForm/V1/AccountForm.vue';
import ProviderButton from '@/components/molecules/ProviderButton/ProviderButton.vue';

import { BUSINESS_ONBOARDING_UUID_CREATION } from '@/store/modules/businessOnboarding';

import uuidv4 from '@/utils/uuidv4';
import { scrollToTop } from '@/utils/scrollToTop';
import { getOauthState } from '@/router/router-utils';
import { OnlineOnboardingURL } from '@/views/Onboarding/helpers';
import BusinessOnboardingModel from '../../BusinessOnboardingModel.vue';
import APIService from '@/api';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    FilledButton,
    TextField,
    AccountForm,
    ProviderButton
  }
})
export default class YourAccount extends BusinessOnboardingModel {
  signUpService = new SignupService();
  coinSetupService = new CoinSetupService();
  internationalizationService = new InternationalizationService();

  oauthState = getOauthState();

  loading = false;
  defaultFormData: BusinessOnboardingAccountForm = this.$store.getters[
    'businessOnboarding/getAccountFormData'
  ];

  handleGoogleSignUp() {
    this.signUpService.signupWithProvider('google', {
      referrerURL: OnlineOnboardingURL.USER_SIGN_UP
    });
  }

  created() {
    if (!localStorage.getItem(BUSINESS_ONBOARDING_UUID_CREATION)) {
      localStorage.setItem(BUSINESS_ONBOARDING_UUID_CREATION, uuidv4());
    }
  }

  mounted() {
    this.verifyErrorQuery();
    scrollToTop('bo-base-layout__right');
  }

  verifyErrorQuery() {
    const { error } = this.$route.query;

    if (error) {
      if (typeof error === 'string') {
        this.$notification(error, 'error');
      }

      this.$router.replace({ query: {} });
    }
  }

  updateUserData(form: AccountFormData) {
    this.$store.dispatch('businessOnboarding/SET_ACCOUNT_FORM', {
      ...form,
      password: ''
    });
  }

  handleBack() {
    this.$router.push(OnlineOnboardingURL.YOUR_BUSINESS);
  }

  get uuid() {
    return localStorage.getItem(BUSINESS_ONBOARDING_UUID_CREATION) || '';
  }

  get provider() {
    if (
      !this.oauthState ||
      !this.oauthState.provider ||
      !this.oauthState.provider.name
    )
      return null;

    return this.oauthState.provider.name;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  async handleSubmit(formData: AccountFormData) {
    this.loading = true;

    const { firstName, lastName, email, password, recaptcha } = formData;

    const manager = {
      fullname: `${firstName} ${lastName}`,
      mail: email,
      password
    };

    if (!APIService.token) {
      const {
        response,
        status,
        data
      } = (await this.signUpService.createManager(
        { manager, anonymousId: segmentIo.getAnonymousId() },
        recaptcha
      )) as any;

      let statusRequest = status ? status : response.status;

      if (statusRequest !== 200) {
        const message =
          statusRequest === 400
            ? 'Email is already registered'
            : response.data.message;

        this.loading = false;
        this.$notification(message, 'error');
        return;
      }

      this.signUpService.setCredentials(data.access_token);
      this.$store.dispatch('businessOnboarding/SET_ACCOUNT_FORM', formData);

      if (this.uuid) await this.coinSetupService.identifyUser(this.uuid);
    }
    const oauthState = getOauthState();

    await this.onCreateBusiness();

    this.onEditedImportedBusinessDate(oauthState);

    this.loading = false;
    this.$router.push(OnlineOnboardingURL.REWARD_RATIO);
  }
}
